module.exports = __webpack_public_path__ + "static/media/overview.beea0fa0.jpg";